import { render, staticRenderFns } from "./RegulationModal.vue?vue&type=template&id=0784b86c"
import script from "./RegulationModal.vue?vue&type=script&lang=js"
export * from "./RegulationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports